import { FC, useState, ChangeEvent } from 'react'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'

import { Layout } from '../../../containers'
import { Title, TextSummary, Select } from '../../../components/UI'
import { ContactForm, ContactsPrevious } from '../../../components'
import { useContacts, useContactsReasons, useFamilyGroup } from '../../../hooks'

const pageSizeDefault: number = 5
const pageDefault: number = 1
const tabClass = 'react-tabs__tab react-tabs_col-2'

const ContactPage:FC = () => {
  const [tabIndex, setTabIndex] = useState<number>(0)
  const contacts = useContacts('', 0, pageDefault, pageSizeDefault)
  const contactReasons = useContactsReasons()
  const familyGroup = useFamilyGroup('FILTER')

  const setContactPage = (pageCurrent: number) => {
    contacts.getByFilter('', 0, pageCurrent, pageSizeDefault)
  }

  const onTabSelectChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const { target: { value } } = event
    setTabIndex(Number(value))
  }

  const onContactPageChange = (pageCurrent: number) => setContactPage(pageCurrent)

  const onContactsChange = () => setContactPage(1)

  const handleTabChange = (newTabIndex: number) => {
    setTabIndex(newTabIndex);
  };

  return (
    <Layout menu titleMain={5}>
      <Title size="20" border className="lg:fz-18">Contáctanos</Title>

      <TextSummary className="mt-30">Para contactarnos por favor completa el siguiente formulario. En un plazo máximo de 48hrs te responderemos por correo electrónico.</TextSummary>

      <Select
        name="tabOptions"
        sizes="md"
        color="primary"
        value={tabIndex}
        fullWidth
        className="lg:d-none mt-50"
        onChange={onTabSelectChange}
      >
        <option value="0">Formulario de contacto</option>
        <option value="1">Contactos anteriores</option>
      </Select>

      <Tabs
        selectedIndex={tabIndex}
        className="lg:mt-25"
        onSelect={(index: number) => setTabIndex(index)}
      >
        <TabList>
          <Tab className={tabClass}>Formulario de contacto</Tab>
          <Tab className={tabClass}>Contactos anteriores</Tab>
        </TabList>

        <TabPanel>
          <ContactForm
            contactReasons={contactReasons.data}
            familyGroup={familyGroup.data}
            className="py-30 lg:py-40 lg:px-30 xl:p-70"
            onChange={onContactsChange}
            setTabIndex={handleTabChange}
          />
        </TabPanel>
        <TabPanel>
          <ContactsPrevious
            data={contacts.data}
            pageDefault={pageDefault}
            pageSizeDefault={pageSizeDefault}
            className="py-30 lg:pt-70 lg:px-60"
            onPageChange={onContactPageChange}
          />
        </TabPanel>
      </Tabs>

    </Layout>
  )
}

export { ContactPage }